import Image from 'next/image'
import { getReadableImageUrl } from "@/lib/directus";
import { sanitizeHTML } from "@/lib/utils";

interface ExpertData {
  heading?: {
    title?: string;
  };
  text?: {
    text?: string;
  };
  button?: {
    label?: string;
    href?: string;
  };
  images?: {
    images_id: {
      alt: string;
      image_file: {
        image: {
          id: string;
          filename_download: string;
        };
      };
    };
  }[];
}

export const fields = [
  "heading.title",
  "text.text",
  "button.label",
  "button.href",
  "images.images_id.alt",
  "images.images_id.image_file.image.id",
  "images.images_id.image_file.image.filename_download",
] as const;

interface ExpertProps {
  data?: ExpertData;
}

export default function Expert({ data }: ExpertProps) {
  // Get the first image from the images array if it exists
  const mainImage = data?.images?.[0]?.images_id;
  const imageId = mainImage?.image_file?.image?.id;
  const imageFilename = mainImage?.image_file?.image?.filename_download;
  const imageAlt = mainImage?.alt;

  return (
    <section className="relative w-full overflow-hidden bg-[#F6F6F6]">
      {/* Desktop and Mobile Hero Section */}
      <div className="mx-auto py-8 xl:py-32">
        <div className="relative lg:flex lg:items-center">
          {/* Image Container */}
          <div className="relative w-full lg:w-3/5 lg:order-2 desktopFadeFromRight">
            <div className="relative h-[489px] lg:h-[842px] overflow-hidden">
              <div className="absolute right-0 w-full h-full lg:rounded-tl-[400px] lg:rounded-bl-[400px] overflow-hidden">
                <Image
                  src={imageId && imageFilename ? getReadableImageUrl(imageId, imageFilename) : "/images/9790004582.jpg_exif11.png"}
                  alt={imageAlt || "Doctor consultation"}
                  fill
                  className="object-cover object-center"
                  priority
                  sizes="(max-width: 768px) 100vw, 50vw"
                  quality={90}
                />
              </div>
            </div>
          </div>


          {/* Content Container */}
          <div className="relative px-5 lg:px-0 lg:w-2/5 lg:pl-28 lg:pr-20 z-10 -mt-[4rem] lg:mt-0">
            <div className="absolute -top-0 left-0 w-full lg:hidden -z-10">
              <Image
                src="/images/top-ellipse.svg"
                alt="Decorative top shape"
                width={393}
                height={39}
                className="w-full h-[5rem] object-cover"
                quality={90}
              />
            </div>

            <h2 className="text-[2rem] font-essonnes text-primary font-light leading-tight md:text-5xl lg:text-[3.375rem] mt-8 pt-16 lg:pt-0"
                dangerouslySetInnerHTML={sanitizeHTML(data?.heading?.title || "")}
            />

            <div className="text-[1rem] font-normal leading-normal lg:text-xl text-primary font-greycliff mt-8 lg:mt-12 lg:leading-[1.35] tracking-tight max-w-[349px] lg:max-w-[529px] [&>*]:text-[1rem] [&>*]:font-normal [&>*]:leading-normal lg:[&>*]:text-xl [&_a]:underline [&_a:hover]:no-underline"
                 dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || "")}
            />

            <a href={data?.button?.href || "#"} className="inline-block mt-6 lg:mt-11 w-full lg:w-auto px-12 py-3 bg-primary text-white rounded-full font-greycliff text-xl tracking-tight hover:bg-[#122947] transition-colors text-center">
              {data?.button?.label}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
} 